import {
  DIARY_DAY_OUTBOX_COLLECTION,
  type DiaryDayOutboxDocType,
} from '@macro-tracker/models';
import { generateId } from '@/utils/id';
import { getDb } from './database';

export async function markDiaryDayDirty(
  userId: string,
  diaryDayId: string,
): Promise<string> {
  const generation = generateId();
  const changedAt = new Date().toISOString();
  const db = await getDb(userId);

  await db[DIARY_DAY_OUTBOX_COLLECTION].incrementalUpsert({
    id: diaryDayId,
    userId,
    generation,
    changedAt,
    pending: true,
  });
  return generation;
}

export async function getPendingDiaryOutbox(
  userId: string,
): Promise<DiaryDayOutboxDocType[]> {
  const db = await getDb(userId);
  const docs = await db[DIARY_DAY_OUTBOX_COLLECTION].find({
    selector: { userId, pending: true },
  }).exec();
  return docs.map((doc) => doc.toMutableJSON());
}

export async function isDiaryDayDirty(
  userId: string,
  diaryDayId: string,
): Promise<boolean> {
  const db = await getDb(userId);
  const doc = await db[DIARY_DAY_OUTBOX_COLLECTION].findOne(diaryDayId).exec();
  return doc?.pending === true;
}

export async function clearDiaryOutboxEntry(
  userId: string,
  diaryDayId: string,
  generation: string,
): Promise<boolean> {
  const db = await getDb(userId);
  const doc = await db[DIARY_DAY_OUTBOX_COLLECTION].findOne(diaryDayId).exec();
  if (!doc || !doc.pending || doc.generation !== generation) return false;

  await doc.incrementalPatch({ pending: false });
  return true;
}
